module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/logo-fcfd2519a2cc2f79931da024c6585d08.png";